import { Route } from "@angular/router";

import { DsV3Plan, hasPermissionGuard, notExternalEntity } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";
import { ACTIVITIES_DS_V3_ROUTES } from "./activities/activities-routes";
import { PROJECTS_DS_V3_ROUTES } from "./projects/projects-routes";

const viewProjectsDashboardPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.PROJECT_PERMISSIONS_DS3.PROJECTS_DASHBOARD,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const DS_V3_DASHBORD_ROUTES: Route[] = [
  {
    path: "projects-dashboard",
    canActivate: [DsV3Plan(), notExternalEntity, ...viewProjectsDashboardPageGuards],
    data: {
      title: "initiatives.dashboard.title",
      breadcrumb: "initiatives.dashboard.title",
    },
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./projects-dashboard/projects-dashboard").then((e) => e.ProjectsDashboardComponent),
      },
    ],
  },
];

export const DS_V3_ROUTES = [...PROJECTS_DS_V3_ROUTES, ...ACTIVITIES_DS_V3_ROUTES];
